import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseContainerComponent } from './cms-collapse-container.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CollapseListModule } from '../../../../../../components/collapse-list/collapse-list.module';
import { SimpleToggleModule } from '../../../../../../components/form-elements/simple-toggle/simple-toggle.module';

@NgModule({
  declarations: [CollapseContainerComponent],
  imports: [CommonModule, CollapseListModule, SimpleToggleModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CollapseContainer: {
          component: CollapseContainerComponent,
        },
      },
    }),
  ],
})
export class CmsCollapseContainerModule {}
